<template>
    <div id="licitacion-toolbar-licitacion">
        <v-toolbar
            flat>
            <v-btn
              v-if="mostrarBtnRegresar"
              icon>
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-toolbar-title
                class="display-1">
                {{ titulo }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <custom-button v-if="mostrarBotonPlantillas"
              label="Plantillas"
              iconText="mdi-file-word-outline"
              tipo="agregar"
              @click="generarNuevaPlantilla"
            >
            </custom-button>
        </v-toolbar>
        <v-dialog v-model="mostrarGenerarNuevaPlantilla"
        scrollable
        persistent
        width="800"
        >
          <generar-nueva-plantilla
          modulo="licitaciones"
          :datos="getDatos"
          :idarchivo="titulo"
          ref="generarNuevaPlantilla"
          @cerrarGenerarNuevaPlantilla="cerrarGenerarNuevaPlantilla">
          </generar-nueva-plantilla>
        </v-dialog>
    </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import GenerarNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/Default.vue';
import mixDatosLicitaciones from '@/components/administracion/configuracion/plantillas/generador/mixDatosLicitaciones';

export default {
  name: 'TituloToolBarLicitacion',
  props: {
    titulo: {
      type: String,
      required: false,
      default: '# Licitacion',
    },
    datos: {
      type: Object,
      required: false,
      default() { return {}; },
    },

    mostrarBtnRegresar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { CustomButton, GenerarNuevaPlantilla },
  mixins: [mixDatosLicitaciones],
  data() {
    return {
      mostrarGenerarNuevaPlantilla: false,
      mostrarBotonPlantillas: true,
    };
  },
  methods: {
    generarNuevaPlantilla() {
      this.mostrarGenerarNuevaPlantilla = !this.mostrarGenerarNuevaPlantilla;
    },
    cerrarGenerarNuevaPlantilla() {
      this.generarNuevaPlantilla();
    },

  },
  computed: {
    getDatos() {
      if (!this.datos) return {};
      return this.formatoWordLicitacion(this.datos);
    },
  },
};
</script>

<style lang="scss">

</style>
